import React from 'react';
import useAnnouncementModalStore from '@/stores/announcementModal/announcementModalStore';
import AnnouncementModal from '@/v3-dashboard/components/AnnouncementModal';

/**
 * AnnouncementModalContainer
 *
 * This component manages the Announcement Modal display.
 * It should be included in the GlobalModals component.
 *
 * The modal will:
 * - Show 24h after login (or first authenticated load) if backend says they haven't seen it
 * - Display in the center (fullscreen)
 * - Track views with event: "announcement_new_design"
 */
const AnnouncementModalContainer = () => {
  const { isOpen, handleClose, handleExplorePlatform, handleReadChangelog } = useAnnouncementModalStore();

  if (!isOpen) return null;

  return (
    <AnnouncementModal
      onClose={handleClose}
      onExplorePlatform={handleExplorePlatform}
      onReadChangelog={handleReadChangelog}
    />
  );
};

export default AnnouncementModalContainer;
